import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ReopeningWizardActions = {
  reopenCase: async ({ commit, state }, legalCaseId) => {
    const payload = {
      reopening_reason: state.reopeningReason,
    }

    return axiosRequest.
      patch(`/legal_cases/${legalCaseId}/reopen`, payload).
      then(({ data }) => {
        commit('setLegalCase', data.legal_case)
        return data
      }).
      catch(handleError)
  },
}

export const ReopeningWizardGetters = {
  reopeningReason: state => state.reopeningReason,
}

export const ReopeningWizardMutations = {
  setReopeningReason: (state, data) => { state.reopeningReason = data },
}

export const ReopeningWizardState = {
  reopeningReason: null,
}
